import traducciones from './contexto.en.json';
import type { Idioma } from '../../i18n/index.js';

/** Resúmenes editoriales, nunca citas: una cita literal conserva siempre su texto original. */
export function contextoEnIdioma(valor: string, idioma: Idioma): string | null {
  if (idioma === 'es') return valor;
  const mapa: Readonly<Record<string, string>> = traducciones;
  return Object.hasOwn(mapa, valor) ? (mapa[valor] ?? null) : null;
}
